<template>
	<div class="canpin">
		<template v-if="headerShow">
			<div class="canpinBox">
				<indexTitle :title="$t('临床应用')" @goMore="goMore"></indexTitle>
				<div class="canpinBox_two">
					<indexHenxiangSwiper ref="indexHenxiangSwiper" :list="swiperList"></indexHenxiangSwiper>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="canpinBox canpinBoxH5">
				<indexTitle :title="$t('配套产品')" @goMore="goMore"></indexTitle>
				<div class="canpinBox_two">
					<indexHenxiangSwiper ref="indexHenxiangSwiper" :list="swiperList"></indexHenxiangSwiper>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import indexTitle from "./indexTitle.vue"
	import indexHenxiangSwiper from "./indexCanpinSwiper.vue"
	export default {
		components: {
			indexTitle,
			indexHenxiangSwiper
		},
		data() {
			return {
				swiperList:[
					// {
					// 	img:require("@/assets/footer/beian.png"),
					// 	name:'电子内镜'
					// },
					// {
					// 	img:require("@/assets/footer/beian.png"),
					// 	name:'电子内镜'
					// },
					// {
					// 	img:require("@/assets/footer/beian.png"),
					// 	name:'电子内镜'
					// },
					// {
					// 	img:require("@/assets/footer/beian.png"),
					// 	name:'电子内镜'
					// },
				]
			}
		},
		mounted() {
			
		},
		methods: {
			goMore(){
				console.log("去更多")
				this.$router.push('/product')
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.canpin {
		width: 100%;
		// min-height: 100vh;
		.canpinBox {
			margin: 0 auto;
			width: 1200px;
			padding: 160px 0;
			box-sizing: border-box;
			
		}
		.canpinBox_two{
			width: 1200px;
			overflow: hidden;
			
			
		}
	}
	@media screen and (max-width:1200px) {
		.canpinBoxH5{
			padding:30px 0 !important;
			max-width: 100% !important;
			width: 100% !important;
			.canpinBox_two{
				max-width: 100% !important;
				width: 100% !important;
			}
		}
		
	}
</style>